//actual used
/**
 * @param {string | number} [seed]
 * @param {number} [diameterArg]
 * @param {string} [className]
 * @returns {string}
 */
export function getJazzicon(seed, diameterArg, className) {
  const diameter = diameterArg || 100;
  seed = seed || Math.random() * Number.MAX_SAFE_INTEGER;
  if (typeof seed !== 'number') seed = hash(seed);

  let colors = [
    // GBIF color scheme
    '#4C9C2E',
    '#231F20',
    '#E37C72',
    '#D1628E',
    '#ECAC7C',
    '#00B7EE',
    '#6885C0',
    '#664192',
    '#F2BF48',
    '#0078B4',
  ];

  let random = mulberry32(seed);

  /**
   * @param {string[]} remainingColors
   * @param {number} total
   * @param {number} i
   */
  function getRectangle(remainingColors, total, i) {
    const center = diameter / 2;
    const firstRot = random();
    const angle = Math.PI * 2 * firstRot;
    const velocity = (diameter / total) * random() + (i * diameter) / total;
    const tx = Math.cos(angle) * velocity;
    const ty = Math.sin(angle) * velocity;
    const translate = 'translate(' + tx + ' ' + ty + ')';

    // Third random is a shape rotation on top of all of that.
    const secondRot = random();
    const rot = firstRot * 360 + secondRot * 180;
    const rotate = 'rotate(' + rot.toFixed(1) + ' ' + center + ' ' + center + ')';
    const transform = translate + ' ' + rotate;
    const fill = genColor(remainingColors, random);

    return `<rect x="0" y="0" width="${diameter}" height="${diameter}" transform="${transform}" fill="${fill}"></rect>`;
  }

  var jazzicon = `<div class="${className}" style="overflow: hidden; background: ${genColor(
    colors,
    random
  )};">
		<svg x="0" y="0" viewBox="0 0 ${diameter} ${diameter}" class="g-w-full g-h-full">
			${getRectangle(colors, 3, 0)}
			${getRectangle(colors, 3, 1)}
			${getRectangle(colors, 3, 2)}
		</svg>
	</div>`;
  return jazzicon;
}

//a hash value based on the username could be used as the seed value
/** @param {string} str */
var hash = function (str) {
  var hash = 0,
    i,
    chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

/** @param {number} a */
function mulberry32(a) {
  return function () {
    var t = (a += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * @param {string[]} colors
 * @param {() => number} random
 */
let genColor = (colors, random) => {
  const idx = Math.floor(colors.length * random());
  const color = colors.splice(idx, 1)[0];
  return color;
};
